import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import Input from "../../shared/components/Input";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import axios from "axios";

const AddStation = (props) => {
	const [isLoading, setIsLoading] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();

	const [formState, inputHandler] = useForm(
		{
			stationName: {
				value: "",
				isValid: false,
			},
			oneJaw1To7: {
				value: "",
				isValid: true,
			},
			twoJaw1To7: {
				value: "",
				isValid: true,
			},
			oneJaw7To14: {
				value: "",
				isValid: true,
			},
			twoJaw7To14: {
				value: "",
				isValid: true,
			},
			twoJaw14To21: {
				value: "",
				isValid: true,
			},
			twoJaw21To28: {
				value: "",
				isValid: true,
			},
			oneJawFull: {
				value: "",
				isValid: true,
			},
			twoJawFull: {
				value: "",
				isValid: true,
			},
		},
		false
	);

	//adding station
	const stationSubmitHandler = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		axios
			.post(
				"/api/v1/laboratorys/create-orderType-process",
				{
					orderTypeId: props.id,
					stationName: formState.inputs.stationName.value,
					oneJaw1To7: formState.inputs.oneJaw1To7.value
						? formState.inputs.oneJaw1To7.value
						: "0",
					twoJaw1To7: formState.inputs.twoJaw1To7.value
						? formState.inputs.twoJaw1To7.value
						: "0",
					oneJaw7To14: formState.inputs.oneJaw7To14.value
						? formState.inputs.oneJaw7To14.value
						: "0",
					twoJaw7To14: formState.inputs.twoJaw7To14.value
						? formState.inputs.twoJaw7To14.value
						: "0",
					twoJaw14To21: formState.inputs.twoJaw14To21.value
						? formState.inputs.twoJaw14To21.value
						: "0",
					twoJaw21To28: formState.inputs.twoJaw21To28.value
						? formState.inputs.twoJaw21To28.value
						: "0",
					oneJawFull: formState.inputs.oneJawFull.value
						? formState.inputs.oneJawFull.value
						: "0",
					twoJawFull: formState.inputs.twoJawFull.value
						? formState.inputs.twoJawFull.value
						: "0",
				},
				{
					headers: {
						authorization: auth.token,
					},
				}
			)
			.then((response) => {
				dispatch({
					type: "update_order_process",
				});
				props.close();
				enqueueSnackbar(response.data.message.message, {
					variant: "success",
				});
			})
			.catch((e) => {
				const messages = e.response.data.message.message;
				Array.isArray(messages)
					? messages.map((message) => {
							enqueueSnackbar(message, { variant: "error" });
					  })
					: enqueueSnackbar(messages, { variant: "error" });
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<React.Fragment>
			<Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
				<Typography variant="h5" align="center" sx={{ mb: 2 }}>
					مرحله کاری جدید
				</Typography>
				{isLoading ? (
					<div style={{ justifyContent: "center", display: "flex" }}>
						<CircularProgress color="inherit" />
					</div>
				) : (
					<form onSubmit={stationSubmitHandler}>
						<Grid container spacing={2}>
							<Grid xs={12}>
								<Input
									id="stationName"
									element="input"
									label="نام مرحله کاری"
									validators={[VALIDATOR_REQUIRE()]}
									errorText="لطفا نام مرحله کاری را وارد کنید."
									onInput={inputHandler}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJaw1To7"
									element="number_only"
									label="1 تا 7 واحد، یک فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw1To7"
									element="number_only"
									label="1 تا 7 واحد، دو فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJaw7To14"
									element="number_only"
									label="7 تا 14 واحد، یک فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw7To14"
									element="number_only"
									label="7 تا 14 واحد، دو فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw14To21"
									element="number_only"
									label="14 تا 21 واحد ، دو فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw21To28"
									element="number_only"
									label="21 تا 28 واحد ، دو فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJawFull"
									element="number_only"
									label="یک فک کامل"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJawFull"
									element="number_only"
									label="دو فک کامل"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفا یک عدد وارد کنید."
									onInput={inputHandler}
									inputValid={true}
									type="text"
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid xs={12} md={6}>
								<Button
									type="submit"
									disabled={!formState.isValid}
									fullWidth
									color="secondary"
									variant="contained"
								>
									ثبت مرحله کاری
								</Button>
							</Grid>
							<Grid xs={12} md={6}>
								<Button
									fullWidth
									color="primary"
									variant="contained"
									onClick={props.close}
								>
									<ArrowBackIcon />
								</Button>
							</Grid>
						</Grid>
					</form>
				)}
			</Paper>
		</React.Fragment>
	);
};

export default AddStation;
